import {getDashboardDataPending,getDashboardDataSuccess,getDashboardDataFail } from "./dashboardSlice";
import { fetchAllDashboardData } from "../../../api/userApi";
import Swal from "sweetalert2";
export const getAllDashboardData = () => async (dispatch) => {
    try {
        //call the api
        dispatch(getDashboardDataPending());
        const result = await fetchAllDashboardData();

        const myJSON = JSON.stringify(result);
        const myObj = JSON.parse(myJSON);
      
        const roledetails = JSON.parse(JSON.stringify(myObj.counts));
     
       
        if (roledetails) {
            console.log('check user profile');
            return dispatch(getDashboardDataSuccess(roledetails));
        }
        dispatch(getDashboardDataFail("User is not found"));


    } catch (error) {
        dispatch(getDashboardDataFail(error));

    }
}


